(function () {
  'use strict';

  angular
    .module('duo-routes.atribuicao-rotas')
    .config(config);

  function config($stateProvider) {
    $stateProvider.state('root.duo-routes-atribuicao', {
      url: '/duo-routes/atribuicao?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'duo-routes/atribuicao/atribuicao-duo-routes.tpl.html',
          controller: 'AtribuicaoDuoRoutesCtrl',
          controllerAs: 'atribuicaoDuoRoutesCtrl'
        }
      },
      data: {
        titulo: 'ce.duoRoutes.atribuicao.titulo',
        hideTitulo: true,
        roles: [['ATRIBUICAO_ROTA_VISUALIZAR']]
      }
    });

    $stateProvider.state('root.duo-routes-atribuicao.form', {
      url: '/form',
      views: {
        'content@': {
          templateUrl: 'duo-routes/atribuicao/form-assignment-duo-routes.tpl.html',
          controller: 'FormAssignmentDuoRoutesCtrl',
          controllerAs: 'FormAssignmentDuoRoutesCtrl'
        }
      },
      data: {
        titulo: 'ce.duoRoutes.atribuicao.titulo',
        hideTitulo: true,
        roles: [['ATRIBUICAO_ROTA_EDITAR']]
      }
    });

    $stateProvider.state('root.duo-routes-atribuicao.details', {
      url: '/details/:UUID',
      views: {
        'content@': {
          templateUrl: 'duo-routes/atribuicao/details-assignment-duo-routes.tpl.html',
          controller: 'DetailsAssignmentDuoRoutesCtrl',
          controllerAs: 'DetailsAssignmentDuoRoutesCtrl'
        }
      },
      data: {
        titulo: 'ce.duoRoutes.atribuicao.titulo',
        hideTitulo: true,
        roles: [['ATRIBUICAO_ROTA_VISUALIZAR']]
      }
    });
  }
}());
